import config from 'config';
import Storage from '../../../../services/Storage';

const storageKey = config.isInspectorArm ? 'inspector_login' : 'login';

export function saveLoginIfNeed(login = '', needSave) {
  if (needSave) {
    Storage.setItem(storageKey, login);
  } else {
    Storage.removeItem(storageKey);
  }
}

export function clearLogin() {
  Storage.removeItem(storageKey);
}

export function getLoginIfExists() {
  return Storage.getItem(storageKey, '');
}
